import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// every request carries the customer being worked on
export function setCustomerHeader(customerId) {
  if (customerId) api.defaults.headers.common["X-Customer-Id"] = customerId;
  else delete api.defaults.headers.common["X-Customer-Id"];
}

setCustomerHeader(localStorage.getItem("kanex.customerId") || "");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errText(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed";
}
